import {
  AtlasBodyMain,
  AtlasBodySubtitle,
  BottomGroupMolecule,
  PageContentAtom,
  PrimaryButtonAtom,
  SecondaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import { useReceiptType } from './ReceiptType.hooks'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

const ReceiptTypePage = () => {
  const isReceiptV2On = useFeatureIsOn('op_receipt_v2')
  const { t, actions } = useReceiptType()

  return (
    <>
      <ToolbarMolecule
        title={t('receipt-type.title')}
        actionIcon="close"
        onAction={actions.onClosePage}
      />

      <PageContentAtom $gap={16}>
        <AtlasBodySubtitle>{t('receipt-type.to-receive')}</AtlasBodySubtitle>
        <AtlasBodyMain>{t('receipt-type.help')}</AtlasBodyMain>

        <BottomGroupMolecule>
          <SecondaryButtonAtom
            type="button"
            onClick={() => {
              actions.onSelectType('transfers')
            }}
          >
            {t('receipt-type.transfers')}
          </SecondaryButtonAtom>
          {!isReceiptV2On && (
          <PrimaryButtonAtom
            type="button"
            onClick={() => {
              actions.onSelectType('providers')
            }}
          >
            {t('receipt-type.providers')}
          </PrimaryButtonAtom>
          )}
        </BottomGroupMolecule>
      </PageContentAtom>
    </>
  )
}

export default ReceiptTypePage
